"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWrapper = exports.HeaderWrapper = void 0;
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var buildBorder = function (props) {
    if (props.HasErrors) {
        return "1px solid " + Theme_1.Color.Red.R60;
    }
    if (props.Appearance === "Standard") {
        if (props.IsDropdownOpen) {
            return "1px solid " + Theme_1.Color.Grey.G30;
        }
        return "1px solid " + Theme_1.Color.Grey.G10;
    }
    else {
        if (props.IsDropdownOpen) {
            return "1px solid " + Theme_1.Color.Grey.G30;
        }
        return "1px solid white";
    }
};
var buildBackground = function (props) {
    if (props.Appearance === "Standard") {
        return Theme_1.Color.Grey.G10;
    }
    return "white";
};
exports.HeaderWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    opacity: ", ";\n    width: 100%;\n    height: 60px;\n    overflow: hidden;\n    box-sizing: border-box;\n    cursor: ", ";;\n"], ["\n    border: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    opacity: ", ";\n    width: 100%;\n    height: 60px;\n    overflow: hidden;\n    box-sizing: border-box;\n    cursor: ", ";;\n"])), buildBorder, buildBackground, function (props) { return props.IsDropdownOpen ? "6px 6px 0 0" : "6px"; }, function (props) { return props.IsDisabled ? Theme_1.DisabledOpacity : 1; }, function (props) { return props.IsDisabled ? "inherit" : "pointer"; });
exports.DropdownWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    border-radius: 0 0 6px 6px;\n    height: 342px;\n    z-index: 1;\n    background-color: white;\n    box-shadow: ", ";\n    border-top: 0;\n    box-sizing: border-box;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* this width makes the sizing in the popper Modifiers work */\n    width: 50px;\n"], ["\n    border: 1px solid ", ";\n    border-radius: 0 0 6px 6px;\n    height: 342px;\n    z-index: 1;\n    background-color: white;\n    box-shadow: ", ";\n    border-top: 0;\n    box-sizing: border-box;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* this width makes the sizing in the popper Modifiers work */\n    width: 50px;\n"])), Theme_1.Color.Grey.G30, Theme_1.BoxShadow.Box30);
var templateObject_1, templateObject_2;
